const AnalyticsService = {
  updateDigitalData: (digitalData) => {
    if (!window) {
      return;
    }
    window.digitalData = { ...digitalData };
  },

  trackEvent: (eventName) => {
    if (!window && !window._satellite) {
      return;
    }
    if (window._satellite && typeof window._satellite.track === 'function') {
      window._satellite.track(eventName);
    }
  },
};

export { AnalyticsService };
